var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1513,
    height: 405,
    viewBox: "0 0 1513 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 91H71V126H56V91Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M63.5 74V151",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 222H318V257H303V222Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M310.5 205V282",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1271,
    y: 203,
    width: 15,
    height: 34,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1278.5 181V258",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 135H141V157.5H126L126 135Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M134 123L134 172",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1433,
    y: 76,
    width: 15,
    height: 14,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1441 57L1441 106",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1338,
    y: 184,
    width: 15,
    height: 21,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1346 177L1346 226",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 118,
    width: 15,
    height: 28,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M729 102L729 151",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782,
    y: 61,
    width: 15,
    height: 15,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M790 45L790 94",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841,
    y: 14,
    width: 15,
    height: 29,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M849 12L849 61",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 25,
    width: 15,
    height: 23,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M908 2L908 51",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 99,
    width: 15,
    height: 23,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1088 89L1088 138",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 158,
    width: 15,
    height: 12,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1148 148L1148 197",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1199,
    y: 204,
    width: 15,
    height: 24,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1207 189L1207 238",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961,
    y: 17,
    width: 15,
    height: 23,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M969 12L969 61",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 49,
    width: 15,
    height: 38,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1028 44L1028 93",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661,
    y: 153,
    width: 15,
    height: 24,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M669 146L669 195",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 239,
    width: 15,
    height: 24,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M491 232L491 281",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 223,
    width: 15,
    height: 24,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M550 216L550 265",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1478,
    y: 13,
    width: 15,
    height: 24,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1486 6L1486 55",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 172,
    width: 15,
    height: 22,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M193 167L193 216",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 210,
    width: 15,
    height: 22,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M252 195L252 244",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 203,
    width: 15,
    height: 13,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M609 176L609 225",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 227,
    width: 15,
    height: 13,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M373 213L373 262",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 257,
    width: 15,
    height: 13,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M432 232L432 281",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1391,
    y: 147,
    width: 15,
    height: 13,
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1399 120L1399 169",
    stroke: "#DEE9FF",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandle);
export default __webpack_public_path__ + "static/media/candle.c409a727.svg";
export { ForwardRef as ReactComponent };